import { LinkPollDataActionTypes, AddLinkPollData, ModifyLinkPollData, DeleteLinkPollData} from 'Actions/ActionTypes/index';
import { Id, LinkPollStatus } from 'NSwag/ServerClient/Client.nswag';


/**
 * Defines methods that create action objects for Link Poll Data
 * in the store
 */

export const addLinkPollData = (linkPollData: LinkPollStatus[]): AddLinkPollData => ({
    type: LinkPollDataActionTypes.AddLinkPollData as LinkPollDataActionTypes.AddLinkPollData,
    linkPollData
});

export const modifyLinkPollData = (linkPollData: LinkPollStatus[]): ModifyLinkPollData => ({
    type: LinkPollDataActionTypes.ModifyLinkPollData as LinkPollDataActionTypes.ModifyLinkPollData,
    linkPollData
});

export const deleteLinkPollData = (ids: Id[]): DeleteLinkPollData => ({
    type: LinkPollDataActionTypes.DeleteLinkPollData as LinkPollDataActionTypes.DeleteLinkPollData,
    ids
});

export type LinkPollDataAction = ReturnType<typeof addLinkPollData | typeof modifyLinkPollData | typeof deleteLinkPollData>